import { Text } from './Text';
import styled from 'styled-components';

export const Title = styled(Text).attrs({
  variant: 'h6',
})`
  ${({ onClick }) => onClick &&
    '&:hover { text-decoration: underline; }'}
`;
